var render = function render(){var _vm=this,_c=_vm._self._c;return _c('main-confirm',{attrs:{"confirm-title":"checkout.everything_is_paid","description":"checkout.description_everything_is_paid","isQuestion":false},on:{"confirm":function($event){return _vm.$emit('confirm')},"cancel":function($event){return _vm.$emit('closeModal')}}},[_c('icon-warning',{attrs:{"size":50}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }